module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPlatinum@2x.4a115da.webp";